
import {Component, Prop, Vue} from "vue-property-decorator";
import {IProfilePayment} from "@/modules/Profile/interfaces/profile-payment.interface";

@Component({})
export default class ProfilePaymentCard extends Vue {
  @Prop() card: IProfilePayment.ICardData;
  @Prop() cashMode!: boolean;

  publicPath = process.env.VUE_APP_PUBLIC_URL;
  specialIcons = ['MIR', 'MASTERCARD', 'VISA'];

  get printedCard() {
    const regex = /^(\w+)\s+(\d{6})\*\*(\d{4})$/;
    const match = this.card.cardName.trim().match(regex);

    if (!match) {
      return {};
    }

    let icon = IProfilePayment.BankNames.find(bank =>
      this.card.bankName.toLowerCase().includes(bank.toLowerCase())
    ) || null;

    return {
      bankType: match[1],
      bin: match[2],
      number: match[3],
      icon,
    };
  }

  setActive() {
    if (this.card.dftFlag) return;
    this.$emit('setActive');
  }

  async deleteCardConfirm() {
    await this.$store.dispatch('confirm/open', {
      title: 'Подтвердите действие',
      text: `Отвязать карту ${this.printedCard.bin.slice(0, 4)} ${this.printedCard.bin.slice(4, 6)}** **** ${this.printedCard.number}?`,
      cancel: {
        text: 'Отменить',
      },
      confirm: {
        text: 'Подтвердить',
        action: () => {
          this.$emit('deleteCard');
        },
      },
    });
  }
}
